import React, { Component } from 'react';
import { RecipeContainer, RecipeDetailsMainContainer, /*RecipeDetailsContainer, FeaturedContainer, AboutRecipe, RecipeBody, RecipeInstructionSection, VideoWrapper, */RecipeInfo, RecipeInfoCards, RecipeTitle, /*StyledTabs*/ } from './styles';
// import { Tab } from "react-bootstrap";
import RecipeIngredients from './RecipeIngredients';
import PropTypes from "prop-types";
import RecipeDirections from './RecipeDirections';
import { connect } from "react-redux";
import { getRecipeDetailsById, updateUserGlobalPoints, getRecommendedRecipeDetails, getFavoriteRecipes, getFeaturedRecipes } from "../../../redux/actions";
import isEmpty from 'lodash/isEmpty';
import Waiting from '../../Waiting';
import { toast } from 'react-toastify';
// import AdventurePointDashBoard from '../../AdventurePointDashBoard/index';
// import { TitleContainer } from '../../Article/styles';
// import ReactPlayer from 'react-player';
import { Circle, Tick, CircleContainerNew } from '../../Journeys/styles';
import { /*ImageContainerIcons,AdminButtons*/  } from '../../Article/styles';
import { withTranslation } from 'react-i18next';
// import {TabsStyle, TabsWrapper} from '../../common/commonStyles';
import { VideoContainerNew } from '../../MainEvents/OnDemandVideoDetailsPage/styles';
import SkeletonLoder from '../../common/skeletonLoder';
// import RecipeGenerator from './RecipeGenerator';
import { ReportHeading } from '../../UserProfile/styles';
import { ArchiveCategoryIcon, BackArrowFeed, ChefIcon, CookIcon, DurationIcon, EditIconBranding, FavouriteIcon, LikeIcon, LunchIcon, PrepIcon, RecognitionEyeIconNew, RestoreCategoryIcon, ServingsIcon } from '../../../utils/icons';
import { ArticleContainer } from '../../Article/styles';
// import LazyImage from '../../common/LazyImage/LazyImage';
import { Border, BorderBottom, TabBottomLine, TabWrapper } from '../../RecogntionAdmin/styles';
import { CardContainer, Title as RecommendedTitle } from '../../AdventureCategories/styles';
import RelatedContent from './relatedContent';
import { NoComments } from '../../SocialFeeds/styles';
import parse from 'react-html-parser';
import RecipeNutritions from './RecipeNutritions';
import { ImageUrl } from '../../../utils/constants';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import CommonModalNew from '../../common/CommonModal/CommonModalNew';
import { fetchApi } from '../../../utils/methods';
import { ArchiveRecipes, RestoreRecipes } from '../../../redux/constants/apiConstants';
import { FetchRecipeDetailsById, LikeUnlikeEducationPost } from '../../../redux/constants/apiConstants';
class RecipeDetails extends Component {
  constructor() {
    super();
    this.state = {
      save: 0,
      like: 0,
      imagestatus: 0,
      showRestoreIcon: false,
      tabValue:1,
      ReactPlayer: null, // store dynamic ReactPlayer component
      loadingVideo: true,
      archivePopup: false,
      restorePopupOpen:false,
      recipeDetailsById:null
    }
  }
  componentDidMount() {

    const { location: { pathname }, /*getRecipeDetailsById*/ } = this.props;
    const StringArray = pathname.split('/');
    // getRecipeDetailsById(StringArray[(StringArray.length - 1)]);
    this.fetchRecipeDetails(StringArray[(StringArray.length - 1)])
  }
  // componentDidUpdate(prevProps) {
  //   const { location, /*getRecipeDetailsById*/ } = this.props;
  //   const StringArray = location.pathname.split('/');
  //   if (location.pathname !== prevProps.location.pathname) {
  //     if (StringArray[(StringArray.length - 1)] != '') {
  //       this.fetchRecipeDetails(StringArray[(StringArray.length - 1)]);
  //     }
  //   }
  //   if (prevProps?.recipeDetailsById?.recipe_details?.video_url !== this.state.recipeDetailsById?.recipe_details?.video_url) {
  //     this.loadReactPlayer();
  //   }
  // }



  componentDidUpdate(prevProps, prevState) {
    const prevRecipe = prevState.recipeDetailsById?.recipe_details;
    const currentRecipe = this.state.recipeDetailsById?.recipe_details;
  
    // 1️⃣ When recipe details arrive / change
    if (
      currentRecipe &&
      (!prevRecipe || prevRecipe.id !== currentRecipe.id)
    ) {
      // Load video player AFTER state update
      // this.loadReactPlayer();
  
      // Sync restore icon from deleted_at
      this.setState({
        showRestoreIcon: currentRecipe.deleted_at !== null,
      });
    }

    const { location, /*getRecipeDetailsById*/ } = this.props;
    const StringArray = location.pathname.split('/');
    if (location.pathname !== prevProps.location.pathname) {
      if (StringArray[(StringArray.length - 1)] != '') {
        this.fetchRecipeDetails(StringArray[(StringArray.length - 1)]);
      }
    }
  }
  



  fetchRecipeDetails = async(id)=>{
    let apiUrl = FetchRecipeDetailsById + "/" + id;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.loadReactPlayer();
        this.setState({recipeDetailsById: res?.data})

      } else {
        toast.error(res?.data?.message || res.data?.[0]);

        window.setTimeout(() => {
          if(res?.data?.code === 422){
            this.props?.history?.goBack();
          }
        }, 3000);
      }
    } catch (error) {
      window.console.error(error);
    }

  }



  loadReactPlayer = async () => {
    // recipeDetails['video_url']
    
    const { video_url } = this.state.recipeDetailsById?.recipe_details || {};

    try {
      let ReactPlayer;

      if (video_url?.includes('vimeo.com')) {
        ReactPlayer = (await import('react-player/vimeo')).default;
      } else if (video_url?.includes('youtube.com') || video_url?.includes('youtu.be')) {
        ReactPlayer = (await import('react-player/youtube')).default;
      } else {
        ReactPlayer = (await import('react-player')).default;
      }

      this.setState({ ReactPlayer });
    } catch (error) {
      window.console.error("Error loading ReactPlayer:", error);
    }
  };

  navigateEditold = () => {
    const { history, recipeDetailsById: { recipe_details: recipeDetails } } = this.props;
    if (recipeDetails && recipeDetails.length === 0 && !recipeDetails['id']) {
      toast.error('Recipe is not found');
      history.push(`/education/recipes`);
    }
    else {
      history.push(`/education/recipes/${recipeDetails['id']}/edit`);
    }
  };


  navigateEdit = () => {
    // const { history, recipeDetailsById: { recipe_details: recipeDetails } } = this.props;
    const { history } = this.props;
    const {  recipeDetailsById: { recipe_details: recipeDetails } } = this.state;
    if (recipeDetails && recipeDetails.length === 0 && !recipeDetails['id']) {
      toast.error('Recipe is not found');
      history.push(`/wellness-resources`);
    }
    else {
      history.push(`/wellness-resources/edit-recipe/${recipeDetails['id']}`);
    }
  };



  ArchiveCatgories = async()=>{

    const { recipeDetailsById } = this.state;
    const { history } = this.props;
    const recipeDetails = recipeDetailsById['recipe_details'];
    const categoryId =  (recipeDetails['id']);
    
    try {
      const res = await fetchApi(ArchiveRecipes + "/" + categoryId, "DELETE");
      if(res.status === 'success'){
        toast.success(res.message);
        history.push(`/company/wellness`, {activeTab: "Library",activeLibraryTab:"Recipes"});
        if(res.data.deleted_at !== null){
          this.setState({showRestoreIcon:true})
        }
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  RestoreCatgories = async()=>{

    const { recipeDetailsById } = this.state;
    const { history } = this.props;
    const recipeDetails = recipeDetailsById['recipe_details'];
    const categoryId =  (recipeDetails['id']);
   
    // const categoryId = selectedRecipe?.article_id; 
    let apiUrl =  RestoreRecipes;
    try {
      const res = await fetchApi(apiUrl + "/" + categoryId, "POST");
      if(res.status === 'success'){
        toast.success(res.message);
        history.push(`/company/wellness`, {activeTab: "Archive",activeLibraryTab:"Recipes"});
        if(res.data.deleted_at === null){
          this.setState({showRestoreIcon:false})
        }
        // setArchiveData(res.data[0].data)
      }else{
        toast.error((res?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  
  



  handleArchivePopup = () => {
    this.setState({archivePopup:true});
    // setSelectedArticle(item);
  }

  handleArchivePopupClose = () => {
    this.setState({archivePopup:false});
  }

  
  
  handleConfirmArchive = () => {
    this.ArchiveCatgories();
    this.setState({archivePopup:false});
  }




  handleRestorePopup = () => {
    this.setState({restorePopupOpen:true});
    // setSelectedArticle(item);
  }

  handleRestorePopupClose = () => {
    this.setState({restorePopupOpen:false});
  }


  handleConfirmRestore = () => {
    this.RestoreCatgories();
    this.setState({restorePopupOpen:false});
  }






  onSave = () => {
    this.setState({
      save: !this.state.save,
    })
  };

  addLike = () => {
    this.setState({
      like: !this.state.like,
    })
  };

  addLikes = (journeys) => {
    // const { onClickFavoriteRibbon } = this.props;
    this.onClickFavoriteRibbon("recipe", journeys.id, journeys.like_status ? 0 : 1, journeys?.favorite_status, 1)
    this.setState({
      like: !this.state.like,
      imagestatus: journeys.like_status===1?1:0
    })

  };

  onClickFavoriteRibbon = async (type, typeId, likeStatus, favouriteStatus) => {

    const { location: { pathname }, /*getRecipeDetailsById*/ } = this.props;
    const StringArray = pathname.split('/');
  
    const payload = {
      type,
      type_id: typeId,
      like_status: likeStatus,
      favorite_status:favouriteStatus
    };
  
    try {
      const res = await fetchApi("/" + LikeUnlikeEducationPost, "POST", payload);
  
      if (res.status === "success") {
        this.fetchRecipeDetails(StringArray[(StringArray.length - 1)])
        // Optimistic UI update
        toast.success(res?.data?.[0]);
        
      }else{

        toast.error(res?.data?.message)

      }
    } catch (error) {
      toast.error("Failed to update favourite");
    }
  };

  saveImage = () => {
    this.setState({
      save: !this.state.save,
    })
  }

  callBack = () => {
    // const { recipeDetailsById, getRecipeDetailsById, getRecommendedRecipeDetails, getFavoriteRecipes, getFeaturedRecipes } = this.props;
    const { recipeDetailsById } = this.state;
    const recipeDetails = recipeDetailsById['recipe_details'];
    // getRecipeDetailsById(recipeDetails['id']);
    // getRecommendedRecipeDetails();
    // getFavoriteRecipes(10);
    // getFeaturedRecipes();
    this.fetchRecipeDetails(recipeDetails['id']);
  }

  updateUserPoints = () => {
    const { updateUserGlobalPoints } = this.props;
    const { recipeDetailsById, } = this.state;
    const recipeDetails = recipeDetailsById['recipe_details'];
    updateUserGlobalPoints(recipeDetails['id'], 23, this.callBack);
  };

  onChangeTabs = (value) =>{
    this.setState({
      tabValue: value
    });
  }

  downloadPdf = async (pdfUrl) => {
    const { recipeDetailsById} = this.state;
    const recipeDetails = recipeDetailsById['recipe_details'];
    try {
      const response = await fetch(ImageUrl + "/" + pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = recipeDetails?.['name'] || 'Recipe'; // You can set the desired file name here
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      window.console.error("Error downloading the image", error);
    }
  };



  redirect = () => {
    const page = this.props.location?.state?.page;
    const libraryPage = this.props.location?.state?.libraryPage;
  
    if (page === "Recipes") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Archive", activeLibraryTab: "Recipes" }
      );
    }else if (libraryPage === "Recipes") {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Library", activeLibraryTab: "Recipes" }
      );
    }
    else {
      this.props.history.goBack()
    }
  }

  render() {
    const { history, recipeLoading, /*updateRecipe,updateUserGlobalPoints,updateRecipe, user onClickFavoriteRibbon,*/ t ,/*recommendedRecipes,*/ role} = this.props;
    const { /*save,*/ like,imagestatus, tabValue, ReactPlayer, loadingVideo,recipeDetailsById,archivePopup,showRestoreIcon,restorePopupOpen } = this.state;

    if (isEmpty(recipeDetailsById) || recipeLoading) {
      return <Waiting />;
    }

    const nutritionDetails = recipeDetailsById?.recipe_details;

    const shouldShowNutritionTab = Boolean(
      nutritionDetails &&
       (
         nutritionDetails?.protein ||
        nutritionDetails?.calories ||
        nutritionDetails?.carbs ||
        nutritionDetails?.fiber ||
        nutritionDetails?.fat ||
        nutritionDetails?.sugar
       )
    );

    const recipeDetails = recipeDetailsById['recipe_details'];
    const selectedCookTimeOption = recipeDetails && recipeDetails['cook_time_option'];
    return (
      <RecipeDetailsMainContainer style={{ "margin-top": history.location.pathname.includes('education') && '-110px' }}>
        {
          recipeDetails ? (
            <>
              <ReportHeading>

                <div className="left-section">
                  <div className="icon" onClick={this.redirect}>
                    {BackArrowFeed('#DA6C74')}
                  </div>
                  {/* <div className="title">{t(recipeDetailsById?.category_tags?.[0]?.recipe_tag)}</div> */}
                  <div className="title">{"Nutrition"}</div>
                </div> 

                <div className="right-section">
                  {role === "ADMIN" && ( showRestoreIcon ? <div className="edit-icon icon-background" onClick={()=>this.handleRestorePopup()} >{RestoreCategoryIcon('#DA6C74')}</div> :<div className="edit-icon icon-background" onClick={()=>this.handleArchivePopup()} >{ArchiveCategoryIcon('#DA6C74')}</div>)}
                  {/* {role === "ADMIN" ?<div className="edit-icon"  onClick={this.handleArchivePopup} >{ArchiveCategoryIcon('#DA6C74')}</div>:null } */}
                  {role === "ADMIN" ?<div className="edit-icon"  onClick={this.navigateEdit}  /*onClick={() => history.push(`/wellness-resources/edit-recipe`)}*/>{EditIconBranding('#DA6C74')}</div>:null }
                </div> 
              </ReportHeading>

              <ArticleContainer>
                <div className="title">{t(recipeDetails?.['name'])}</div>
                <VideoContainerNew margin={'15px'} loadingVideo={loadingVideo} style={{float:'unset'}} height={'679px'}>
                  {ReactPlayer ? <ReactPlayer
                    className="react-player"
                    url={recipeDetails['video_url']}
                    onEnded={this.updateUserPoints}
                    controls
                    key={recipeDetails['video_url']}
                    onReady={() => this.setState({ loadingVideo: false })}
                  />: <div>Loading...</div>}
                  {loadingVideo ? <SkeletonLoder width={"640px"} height={"470px"}/>:null}
                </VideoContainerNew>
                <div className='icon-container' style={{marginBottom:'0px'}}>
                  <div className='row-1'>
                    <div className='icons like-container'>
                      {/* {!imagestatus && (like || recipeDetails.like_status)? <LazyImage className={'image'} src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLike(recipeDetails)} />:<LazyImage className={'image'} src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLike(recipeDetails)} /> } */}
                      <span onClick={() => this.addLikes(recipeDetails)} className='like-icon' style={{cursor:'pointer'}}>{<LikeIcon fill={!imagestatus && (like || recipeDetails.like_status) ? "#DA6C74" : "none"}/>}</span>

                      <span className='count'>{recipeDetails['likes_count']}</span>
                    </div>
       
                    <div className='icons'>
                      <span style={{cursor:'pointer'}} onClick={() => { this.onClickFavoriteRibbon("recipe", recipeDetails.id, recipeDetails.like_status, recipeDetails?.favorite_status ? 0 : 1, 0); this.saveImage() }} className='like-icon'>{<FavouriteIcon fill={recipeDetails?.favorite_status? "#DA6C74" : "none"}/>}</span>
                    </div>
       
                  </div>
       
                  <div className='row-2'>
                    <div className='icons like-container'>
                      <span className='like-icon'>{RecognitionEyeIconNew('#DA6C74')}</span>
                      <span className='count'>{recipeDetails.seen_count}</span>
                    </div>
                    <div className='icons'>
                      {/* <CircleContainerNew marginRight={1} font={"14px"}>
                        <div className="flex">
                          <Circle borderColor="#DA6C74" checked={recipeDetails.read_status} width={'20px'} height={'20px'} borderWidth={'1px'}>
                            <Tick checked={recipeDetails.read_status} width={'5px'} height={'10px'} left={'5px'}/>
                          </Circle>
                        </div>
                        <div className="quiz">
                          {t("Article")}
                        </div>
                      </CircleContainerNew> */}
                      <CircleContainerNew>
                        <div className="flex">
                          <Circle borderColor="#DA6C74" checked={recipeDetails['view_status']} width={'20px'} height={'20px'} borderWidth={'1px'}>
                            <Tick checked={recipeDetails['view_status']} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                          </Circle>
                        </div>
                        <div className="quiz">
                          {t("Watched")}
                        </div>
                      </CircleContainerNew>
                    </div>
                    
                  </div>
                </div>
              </ArticleContainer>
              <ArticleContainer style={{margin:'20px 0px'}}>
                <RecipeContainer>
                  <div className='heading'>About the recipe :</div>
                  <div className='desc'>{parse(recipeDetails['description'])}</div>
                  <Border background={'#DCDCDC'} margin={'20px 0px'}/>

                  <div className='recipe-details'>
                    <div className='ingredients'>
                      <TabWrapper>
                        <TabBottomLine onClick={()=>this.onChangeTabs(1)} active={tabValue===1} background={'#DA6C74'}>
                        Ingredients
                          <BorderBottom onClick={()=>this.onChangeTabs(1)} active={tabValue===1} background={'#DA6C74'} />
                        </TabBottomLine>
                        <TabBottomLine onClick={()=>this.onChangeTabs(2)} active={tabValue===2} background={'#DA6C74'}>
                        Directions
                          <BorderBottom onClick={()=>this.onChangeTabs(2)} active={tabValue===2} background={'#DA6C74'} />
                        </TabBottomLine>
                        {shouldShowNutritionTab && <TabBottomLine onClick={()=>this.onChangeTabs(3)} active={tabValue===3} background={'#DA6C74'}>
                        Nutrition Facts
                          <BorderBottom onClick={()=>this.onChangeTabs(3)} active={tabValue===3} background={'#DA6C74'} />
                        </TabBottomLine>}
                      </TabWrapper>

                      {tabValue===1?<RecipeIngredients ingredients={recipeDetailsById['ingredients']} categoryTagsList={recipeDetailsById['category_tags']} />: tabValue===2 ?
                        <RecipeDirections history={history} recipeDetails={recipeDetails} directions={recipeDetailsById['directions']} images={recipeDetailsById['recipe_images']} updateUserGlobalPoints={updateUserGlobalPoints} ingredients={recipeDetailsById['ingredients']} categoryTagsList={recipeDetailsById['category_tags']} /> : 
                        ( shouldShowNutritionTab && (<RecipeNutritions recipeDetails={nutritionDetails} />))
                      }

                      {recipeDetails?.recipe_pdf ? <CommonButtonPopup margin={'12px 0px'} background={'#DA6C74'} onClick={()=>this.downloadPdf(recipeDetails?.recipe_pdf)}>Print Recipe</CommonButtonPopup>:null}

                    </div>

                    <div className='overview'>
   
                      <RecipeInfo>
                        <RecipeTitle>{t("Recipe Overview")}:</RecipeTitle>

                        <RecipeInfoCards>
                          <div className='icon'> {ServingsIcon()}
                          </div>
                          <div><span>{recipeDetails['servings']} {Number(recipeDetails['servings']) > 1 ? 'Servings' : "Serving"} </span>
                          </div>
                        </RecipeInfoCards>

                        <RecipeInfoCards>
                          <div className='icon'> {ChefIcon()}
                          </div>
                          <div><span>{recipeDetails['level']}</span>
                          </div>
                        </RecipeInfoCards>
       
                        <RecipeInfoCards>
                          <div className='icon'> {LunchIcon()}
                          </div>
                          <div><span>{recipeDetails['meal_type']}</span>
                          </div>
                        </RecipeInfoCards>
                        <RecipeInfoCards>
                          <div className='icon'> {PrepIcon()}
                          </div>
                          <div><span>{t("Prep")} :&nbsp;</span><span>{`${recipeDetails['prep_time']} mins`}</span>
                          </div>
                        </RecipeInfoCards>
                        <RecipeInfoCards>
                          <div className='icon'> {CookIcon()}
                          </div>
                          <div>
                            <span>{t("Cook")} : {selectedCookTimeOption ? recipeDetails['cook_time'] : `${recipeDetails['cook_time']} mins`}</span>
                          </div>
                        </RecipeInfoCards>
                        <RecipeInfoCards>
                          <div className='icon'> {DurationIcon()}
                          </div>
                          <div>
                            <span>{t("Total")} :&nbsp;</span><span>{`${recipeDetails['total_time']} mins`}</span>
                          </div>
                        </RecipeInfoCards>
                      </RecipeInfo>

                    </div>

                  </div>
                </RecipeContainer>
              </ArticleContainer>

              <div>
                <RecommendedTitle videoCSS={1}>{t("Related Recipes")}</RecommendedTitle>
                <CardContainer>
                  {!recipeDetailsById?.related_recipes?.length ? <NoComments>{t("No Related Recipes")}</NoComments> :
                    recipeDetailsById?.related_recipes?.map((video, index) => (
                      <RelatedContent video={video} key={index} history={history} bottom={"25px"} width={'calc((100% / 2) - 12.5px)'} onClickFavoriteRibbon={this.onClickFavoriteRibbon} />
                    ))
                  }
                </CardContainer>
              </div>
              {/* <RecipeDetailsContainer>
                <TitleContainer float={'right'}>
                  <div>
                    <span >{recipeDetails['name']}</span>
                  </div>
                  <div>
                    <div>{recipeDetails['title']}</div>
                    <div>
                      {save !== 0 || recipeDetails?.favorite_status ?
                        <img src="/public/images/NewDashboardV2/ribbonColor.png" onClick={() => { onClickFavoriteRibbon("recipe", recipeDetails.id, 0, recipeDetails?.favorite_status ? 0 : 1, 0); this.saveImage() }} /> :
                        <img src="/public/images/NewDashboardV2/ribbonNew.png" onClick={() => { onClickFavoriteRibbon("recipe", recipeDetails.id, 0, recipeDetails?.favorite_status ? 0 : 1, 0); this.saveImage() }} />
                      }
                    </div>
                  </div>
                </TitleContainer>
                <VideoWrapper>
                  <VideoContainerNew margin={'15px'} loadingVideo={loadingVideo}>
                    {ReactPlayer ? <ReactPlayer
                      className="react-player"
                      url={recipeDetails['video_url']}
                      onEnded={this.updateUserPoints}
                      controls
                      key={recipeDetails['video_url']}
                      onReady={() => this.setState({ loadingVideo: false })}
                    />: <div>Loading...</div>}
                    {loadingVideo ? <SkeletonLoder width={"640px"} height={"470px"}/>:null}
                  </VideoContainerNew>
                  <ImageContainerIcons padding={'15px'}>
                    <div>
                      <div>
                        {!imagestatus && (like || recipeDetails.like_status)? <img src="/public/images/NewDashboardV2/ColorLike.png" alt="like" onClick={() => this.addLikes(recipeDetails)} />:<img src="/public/images/NewDashboardV2/like.png" alt="like" onClick={() => this.addLikes(recipeDetails)} /> }
                        {<span>{recipeDetails['likes_count']}</span>}
                      </div>
   
                      <div>
                        <img src="/public/images/NewDashboardV2/view.png" alt="view" />
                        <span>{recipeDetails['seen_count']}</span>
                      </div>
                    </div>
                    <div >
                      <CircleContainerNew style={{ "marginLeft": "15px" }}>
                        <div className="flex">
                          <Circle borderColor="#DA6C74" checked={recipeDetails['view_status']}>
                            <Tick checked={recipeDetails['view_status']} />
                          </Circle>
                        </div>
                        <div className="quiz">
                          {t("Watched")}
                        </div>
                      </CircleContainerNew>
                    </div>
                  </ImageContainerIcons>
                </VideoWrapper>
                <AboutRecipe>
                  <RecipeBody>
                    <div className="recipeHeader">{t("About the recipe")}:</div>
                    <div className="recipeDescription">{recipeDetails['description']}</div>
                  </RecipeBody>
   
                  <RecipeInfo>
                    <RecipeTitle>{t("Recipe Information")}:</RecipeTitle>
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/schef.png" alt="view" />
                      </div>
                      <div><span>{recipeDetails['level']}</span>
                      </div>
                    </RecipeInfoCards>
   
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/serve.png" alt="view" />
                      </div>
                      <div><span>{recipeDetails['servings']}</span>
                      </div>
                    </RecipeInfoCards>
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/snacks.png" alt="view" />
                      </div>
                      <div><span>{recipeDetails['meal_type']}</span>
                      </div>
                    </RecipeInfoCards>
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/prep.png" alt="view" />
                      </div>
                      <div><span>{t("Prep")} :&nbsp;</span><span>{`${recipeDetails['prep_time']}mins`}</span>
                      </div>
                    </RecipeInfoCards>
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/cook.png" alt="view" />
                      </div>
                      <div>
                        <span>{t("Cook")} : {selectedCookTimeOption ? recipeDetails['cook_time'] : `${recipeDetails['cook_time']}mins`}</span>
                      </div>
                    </RecipeInfoCards>
                    <RecipeInfoCards>
                      <div> <img src="/public/images/NewDashboardV2/time.png" alt="view" />
                      </div>
                      <div>
                        <span>{t("Total")} :&nbsp;</span><span>{`${recipeDetails['total_time']}mins`}</span>
                      </div>
                    </RecipeInfoCards>
                  </RecipeInfo>
                </AboutRecipe>
                <RecipeInstructionSection>
                  <TabsWrapper >
                    <TabsStyle  onClick={()=>this.onChangeTabs(1)} active={tabValue===1}>
                      Ingredients
                    </TabsStyle>
                    <TabsStyle onClick={()=>this.onChangeTabs(2)} active={tabValue===2}>
                      Steps
                    </TabsStyle>
                  </TabsWrapper>
                  {tabValue===1?<RecipeIngredients ingredients={recipeDetailsById['ingredients']} categoryTagsList={recipeDetailsById['category_tags']} />:
                    <RecipeDirections history={history} recipeDetails={recipeDetails} directions={recipeDetailsById['directions']} images={recipeDetailsById['recipe_images']} updateUserGlobalPoints={updateUserGlobalPoints} ingredients={recipeDetailsById['ingredients']} categoryTagsList={recipeDetailsById['category_tags']} />}
                </RecipeInstructionSection>
              </RecipeDetailsContainer> */}
            </>
          ): null
        }


        {archivePopup && <CommonModalNew
          show={archivePopup}
          icon={ArchiveCategoryIcon("#184A61")}
          title="Archive Recipe"
          description="Are you sure you want to Archive this recipe?"
          subDescription="You can view the archived data in archive tab of wellness resources"
          onCancel={this.handleArchivePopupClose}
          onConfirm={this.handleConfirmArchive}
          cancelText="Keep Recipe"
          confirmButtonText="Archive"
          buttonIcon={ArchiveCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}



        {restorePopupOpen && <CommonModalNew
          show={restorePopupOpen}
          icon={RestoreCategoryIcon("#184A61")}
          title="Restore Recipe"
          description="Are you sure you want to restore this recipe?"
          subDescription="You can view these recipe in the category you have uploaded"
          onCancel={this.handleRestorePopupClose}
          onConfirm={this.handleConfirmRestore}
          cancelText="Keep Recipe"
          confirmButtonText="Restore"
          buttonIcon={RestoreCategoryIcon("white")}
          modalHeight="261px"
          confirmButtonWidth="200px"
        />}
        {/* <FeaturedContainer width={"32%"} padding={"25"}>
          {updateRecipe &&
            <AdminButtons background={'#9FC989'} onClick={this.navigateEditold}>
              <div>
                <img src="/public/images/NewDashboardV2/editrecipe.png" alt="editrecipe" />
              </div>
              <div>
                {t("Edit Video")}
              </div>
            </AdminButtons>
          }
          {user?.company_id != 1 && <AdventurePointDashBoard /> }
          {user?.company_id === 1 &&<RecipeGenerator recipeDetails={recipeDetails} ingredients={recipeDetailsById['ingredients']}/>}
        </FeaturedContainer> */}
      </RecipeDetailsMainContainer>
    );
  }
}
RecipeDetails.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  getRecipeDetailsById: PropTypes.func,
  recipeDetailsById: PropTypes.object,
  editRecipe: PropTypes.func,
  role: PropTypes.string,
  recipeLoading: PropTypes.bool,
  updateUserGlobalPoints: PropTypes.func.isRequired,
  updateRecipe: PropTypes.bool,
  onClickFavoriteRibbon: PropTypes.func,
  getRecommendedRecipeDetails: PropTypes.func,
  getFavoriteRecipes: PropTypes.func,
  getFeaturedRecipes: PropTypes.func,
  t: PropTypes.func,
  user:PropTypes.object,
  recommendedRecipes:PropTypes.array,
  match:PropTypes.object
};
const mapStateToProps = (state) => ({
  recipeDetailsById: state.education.recipeDetailsById,
  recipeLoading: state.education.recipeLoading,
  user: state.profileData.user,
  recommendedRecipes: state.education.recommendedRecipes,
});
const mapDispatchToProps = (dispatch) => ({
  getRecipeDetailsById: (id) => dispatch(getRecipeDetailsById(id)),
  updateUserGlobalPoints: (actionId, activityType, callBackForUpdaingApiDetails) => dispatch(updateUserGlobalPoints(actionId, activityType, callBackForUpdaingApiDetails)),
  getRecommendedRecipeDetails: () => dispatch(getRecommendedRecipeDetails()),
  getFavoriteRecipes: (id) => dispatch(getFavoriteRecipes(id)),
  getFeaturedRecipes: () => dispatch(getFeaturedRecipes()),
})
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RecipeDetails));